import DefaultLayout from 'components/layout/DefaultLayout';
import OrgClientDashboard from 'components/org-client/OrgClientDashboard';
import OrgClientDepartments from 'components/org-client/OrgClientDepartments';
import OrgClientMembers from 'components/org-client/OrgClientMembers';
import OrgClientPlans from 'components/org-client/OrgClientPlans';
import OrgClientReports from 'components/org-client/OrgClientReports';
import OrgClientWellbeing from 'components/org-client/OrgClientWellbeing';
import routes from 'common/routes';
import { roles } from 'common/constants/options';

// Panel de la empresa cliente. El gestor NO es un rol aparte sino un CLIENT con el flag
// `is_org_manager` (así la misma persona puede entrenar sin abrir una segunda cuenta), por eso
// el guard de rol es `client` y el filtro fino lo hace `requiresOrgManager` en el router.
// Sin `requiresMembership` ni `allowedPlatforms`: el panel no depende de que el gestor tenga
// plan propio ni de en qué canal esté.
const orgClientRoutes = [
  {
    key: 'org-client-dashboard',
    exact: true,
    path: routes.orgClientDashboard.path,
    component: OrgClientDashboard,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresOrgManager: true
  },
  {
    key: 'org-client-wellbeing',
    exact: true,
    path: routes.orgClientWellbeing.path,
    component: OrgClientWellbeing,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresOrgManager: true
  },
  {
    key: 'org-client-departments',
    exact: true,
    path: routes.orgClientDepartments.path,
    component: OrgClientDepartments,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresOrgManager: true
  },
  {
    key: 'org-client-members',
    exact: true,
    path: routes.orgClientMembers.path,
    component: OrgClientMembers,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresOrgManager: true
  },
  {
    key: 'org-client-reports',
    exact: true,
    path: routes.orgClientReports.path,
    component: OrgClientReports,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresOrgManager: true
  },
  {
    key: 'org-client-plans',
    exact: true,
    path: routes.orgClientPlans.path,
    component: OrgClientPlans,
    layout: DefaultLayout,
    allowedRoles: [roles.client],
    requiresOrgManager: true
  }
];

export default orgClientRoutes;
